"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _PosterPopup = _interopRequireDefault(require("./components/PosterPopup.vue"));
var _posterManagement = require("@/api/operationManagement/posterManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    PosterPopup: _PosterPopup.default
  },
  data: function data() {
    return {
      loading: false,
      nameList: [{
        name: '活动海报',
        id: 1
      }, {
        name: '平台海报',
        id: 2
      }, {
        name: '引流海报',
        id: 3
      }, {
        name: '外卖海报',
        id: 4
      }, {
        name: '生活海报',
        id: 5
      }],
      pagination: {
        total: 0 // 条数
      },
      queryData: {
        appId: 2,
        enable: null,
        platformType: 1,
        page: {
          page: 1,
          size: 10
        }
      },
      dataList: []
    };
  },
  created: function created() {
    this.listPosterApi();
  },
  methods: {
    onChangeName: function onChangeName(id) {
      this.queryData.platformType = id;
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.listPosterApi();
    },
    onAdd: function onAdd() {
      this.$refs.PosterPopup.open({
        platformType: this.queryData.platformType,
        type: 'add'
      });
    },
    onEditor: function onEditor(val) {
      this.$refs.PosterPopup.open({
        id: val.id,
        type: 'editor'
      });
    },
    onRefresh: function onRefresh() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.listPosterApi();
    },
    onDelete: function onDelete(val) {
      var _this = this;
      this.$confirm('是否确认删除此海报?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deletePosterApi(Number(val.id));
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.listPosterApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.listPosterApi();
    },
    listPosterApi: function () {
      var _listPosterApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              this.loading = true;
              _context.n = 1;
              return (0, _posterManagement.listPosterApi)(params);
            case 1:
              res = _context.v;
              this.loading = false;
              if (res.code === 0) {
                this.dataList = res.data.records;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.loading = false;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listPosterApi() {
        return _listPosterApi2.apply(this, arguments);
      }
      return listPosterApi;
    }(),
    deletePosterApi: function () {
      var _deletePosterApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                id: id,
                appId: 2
              };
              _context2.n = 1;
              return (0, _posterManagement.deletePosterApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
                this.listPosterApi();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function deletePosterApi(_x) {
        return _deletePosterApi2.apply(this, arguments);
      }
      return deletePosterApi;
    }()
  }
};